import { render } from "./legoActionBar.vue?vue&type=template&id=5fdd52d2"
import script from "./legoActionBar.vue?vue&type=script&lang=js"
export * from "./legoActionBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/lego-component/components/element/legoActionBar/legoActionBar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5fdd52d2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5fdd52d2', __exports__)) {
    api.reload('5fdd52d2', __exports__)
  }
  
  module.hot.accept("./legoActionBar.vue?vue&type=template&id=5fdd52d2", () => {
    api.rerender('5fdd52d2', render)
  })

}


export default __exports__